import { config } from "src/config/config";
import { AjaxStatus } from "src/service/api_types";
import {
  getAssetsCreatedByUserAPI,
  updateAssetAPI,
  delistAssetAPI,
  copyAssetAPI,
  listAssetAPI,
  offerTradingAssetAPI,
  distributeAssetAPI,
  getFlowTransactionStatusAPI,
} from "src/service/user_asset_api";
import { loadStripe } from "@stripe/stripe-js";

export const USER_ASSET_ACTIONS = {
  INIT_ASSETS_CREATED_BY_USER: "INIT_ASSETS_CREATED_BY_USER",
  START_ASSETS_CREATED_BY_USER: "START_ASSETS_CREATED_BY_USER",
  GET_ASSETS_CREATED_BY_USER: "GET_ASSETS_CREATED_BY_USER",
  UPDATE_ASSET: "UPDATE_ASSET",
  INIT_UPDATE_ASSET: "INIT_UPDATE_ASSET",
  START_UPDATE_ASSET: "START_UPDATE_ASSET",
  DELIST_ASSET: "DELIST_ASSET",
  INIT_COPY_ASSET: "INIT_COPY_ASSET",
  START_COPY_ASSET: "START_COPY_ASSET",
  COPY_ASSET: "COPY_ASSET",
  INIT_DELIST_ASSET: "INIT_DELIST_ASSET",
  START_DELIST_ASSET: "START_DELIST_ASSET",
  LIST_ASSET: "LIST_ASSET",
  INIT_LIST_ASSET: "INIT_LIST_ASSET",
  START_LIST_ASSET: "START_LIST_ASSET",
  OFFER_TRADING_ASSET: "OFFER_TRADING_ASSET",
  INIT_OFFER_TRADING_ASSET: "INIT_OFFER_TRADING_ASSET",
  START_OFFER_TRADING_ASSET: "START_OFFER_TRADING_ASSET",
  DISTRIBUTE_ASSET: "DISTRIBUTE_ASSET",
  INIT_DISTRIBUTE_ASSET: "INIT_DISTRIBUTE_ASSET",
  START_DISTRIBUTE_ASSET: "START_DISTRIBUTE_ASSET",
  SALE_ASSETS_SELECTED: "SALE_ASSETS_SELECTED",
  INIT_GET_FLOW_TX_STATUS: "INIT_GET_FLOW_TX_STATUS",
  START_GET_FLOW_TX_STATUS: "START_GET_FLOW_TX_STATUS",
  GET_FLOW_TX_STATUS: "GET_FLOW_TX_STATUS",
};

export const getAssetsCreatedByUser = (data: any) => ({
  type: USER_ASSET_ACTIONS.GET_ASSETS_CREATED_BY_USER,
  data,
});

export const initAssetsCreatedByUser = () => ({
  type: USER_ASSET_ACTIONS.INIT_ASSETS_CREATED_BY_USER,
});

export const startAssetsCreatedByUser = () => ({
  type: USER_ASSET_ACTIONS.START_ASSETS_CREATED_BY_USER,
});

export const updateAsset = (data: any) => ({
  type: USER_ASSET_ACTIONS.UPDATE_ASSET,
  data,
});

export const initUpdateAsset = () => ({
  type: USER_ASSET_ACTIONS.INIT_UPDATE_ASSET,
});

export const startUpdateAsset = () => ({
  type: USER_ASSET_ACTIONS.START_UPDATE_ASSET,
});

export const delistAsset = (data: any) => ({
  type: USER_ASSET_ACTIONS.DELIST_ASSET,
  data,
});

export const initCopyAsset = () => ({
  type: USER_ASSET_ACTIONS.INIT_COPY_ASSET,
});

export const startCopyAsset = () => ({
  type: USER_ASSET_ACTIONS.START_COPY_ASSET,
});

export const copyAsset = (data: any) => ({
  type: USER_ASSET_ACTIONS.COPY_ASSET,
  data,
});

export const initDistributeAsset = () => ({
  type: USER_ASSET_ACTIONS.INIT_DISTRIBUTE_ASSET,
});

export const startDistributeAsset = () => ({
  type: USER_ASSET_ACTIONS.START_DISTRIBUTE_ASSET,
});

export const distributeAsset = (data: any) => ({
  type: USER_ASSET_ACTIONS.DISTRIBUTE_ASSET,
  data,
});

export const saleAssetsSelected = (data: any) => ({
  type: USER_ASSET_ACTIONS.SALE_ASSETS_SELECTED,
  data,
});

export const initDelistAsset = () => ({
  type: USER_ASSET_ACTIONS.INIT_DELIST_ASSET,
});

export const startDelistAsset = () => ({
  type: USER_ASSET_ACTIONS.START_DELIST_ASSET,
});

export const initListAsset = () => ({
  type: USER_ASSET_ACTIONS.INIT_LIST_ASSET,
});

export const startListAsset = () => ({
  type: USER_ASSET_ACTIONS.START_LIST_ASSET,
});

export const listAsset = (data: any) => ({
  type: USER_ASSET_ACTIONS.LIST_ASSET,
  data,
});

export const initOfferTradingAsset = () => ({
  type: USER_ASSET_ACTIONS.INIT_OFFER_TRADING_ASSET,
});

export const startOfferTradingAsset = () => ({
  type: USER_ASSET_ACTIONS.START_OFFER_TRADING_ASSET,
});

export const offerTradingAsset = (data: any) => ({
  type: USER_ASSET_ACTIONS.OFFER_TRADING_ASSET,
  data,
});

export const initGetFlowTransactionStatus = (data?: any) => ({
  type: USER_ASSET_ACTIONS.INIT_GET_FLOW_TX_STATUS,
  data,
});

export const startGetFlowTransactionStatus = () => ({
  type: USER_ASSET_ACTIONS.START_GET_FLOW_TX_STATUS,
});

export const getFlowTransactionStatus = (data: any) => ({
  type: USER_ASSET_ACTIONS.GET_FLOW_TX_STATUS,
  data,
});

export const getAssetsCreatedByUserDispatch =
  (params: any) => (dispatch: Function) => {
    let options = {
      pageNumber: params.pageNumber,
      pageSize: params.pageSize,
      assetType: params.assetType,
      mediaType: params.mediaType,
      bizCond: params.bizCond,
      sortBy: params.sortBy,
    };

    dispatch(startAssetsCreatedByUser());

    return getAssetsCreatedByUserAPI(options)
      .done((data, status, xhr) => {
        if (config.APP_DEBUG) {
          console.log("Headers: ", xhr.getAllResponseHeaders());
          console.log("Received assets created by user: ", data);
        }
        let assetsData = {
          pageNumber: params.pageNumber,
          pageSize: params.pageSize,
          response: data,
          ajaxStat: AjaxStatus.DONE,
        };
        dispatch(getAssetsCreatedByUser(assetsData));
      })
      .fail((err) => {
        if (config.APP_DEBUG) {
          console.error("Error in getting assets created by user");
        }
        let assetsData = {
          response: {},
          ajaxStat: AjaxStatus.FAILED,
        };
        dispatch(getAssetsCreatedByUser(assetsData));
      });
  };

export const updateAssetDispatch = (params: any) => (dispatch: Function) => {
  let options = {
    assetTokenID: params.assetTokenID,
    title: params.title,
    description: params.description,
    brand_id: params.brand_id,
    group_key: params.group_key,
    assetType: params.assetType,
    batch: params.batch,
    creatorRoyaltyRate: params.creatorRoyaltyRate,
    rentalCreatorRoyaltyRate: params.rentalCreatorRoyaltyRate,
    saleStartingAt: params.saleStartingAt,
    saleEndingAt: params.saleEndingAt,
    secondarySaleEnabled: params.secondarySaleEnabled,
    tradeEnabled: params.tradeEnabled,
    secondaryRentalEnabled: params.secondaryRentalEnabled,
    onlyJapanAccessible: params.onlyJapanAccessible,
    minSellablePrice: params.minSellablePrice,
    downloadEnabled: params.downloadEnabled,
  };

  dispatch(startUpdateAsset());

  return updateAssetAPI(options)
    .done((data, status, xhr) => {
      if (config.APP_DEBUG) {
        console.log("Headers: ", xhr.getAllResponseHeaders());
        console.log("Updated asset: ", data);
      }
      dispatch(
        updateAsset({
          ajaxStat: AjaxStatus.DONE,
          response: data,
        })
      );
    })
    .fail((err) => {
      if (config.APP_DEBUG) {
        console.error("Error in updating asset");
      }
      dispatch(
        updateAsset({
          response: {},
          ajaxStat: AjaxStatus.FAILED,
        })
      );
    });
};

export const delistAssetDispatch = (params: any) => (dispatch: Function) => {
  const options = {
    assets: params.assets,
    batch: params.batch,
  };

  dispatch(startDelistAsset());

  return delistAssetAPI(options)
    .done((data, status, xhr) => {
      if (config.APP_DEBUG) {
        console.log("Headers: ", xhr.getAllResponseHeaders());
        console.log("Delisted asset: ", data);
      }
      dispatch(
        delistAsset({
          ajaxStat: AjaxStatus.DONE,
          response: data,
        })
      );
    })
    .fail((err) => {
      if (config.APP_DEBUG) {
        console.error("Error in delisting asset");
      }
      dispatch(
        delistAsset({
          response: {},
          ajaxStat: AjaxStatus.FAILED,
        })
      );
    });
};

export const copyAssetDispatch = (params: any) => (dispatch: Function) => {
  let options = {
    copies_count: params.copies_count,
    title: params.title,
    description: params.description,
    kid: params.kid,
    asset_type: params.asset_type,
  };

  dispatch(startCopyAsset());

  return copyAssetAPI(options)
    .done((data, status, xhr) => {
      if (config.APP_DEBUG) {
        console.log("Headers: ", xhr.getAllResponseHeaders());
        console.log("Copied asset: ", data);
      }
      dispatch(
        copyAsset({
          ajaxStat: AjaxStatus.DONE,
          response: data,
        })
      );
    })
    .fail((err) => {
      if (config.APP_DEBUG) {
        console.error("Error in Copying asset");
      }
      dispatch(
        copyAsset({
          response: {},
          ajaxStat: AjaxStatus.FAILED,
        })
      );
    });
};

export const listAssetDispatch = (params: any) => (dispatch: Function) => {
  let options = {
    assetTokenIDs: params.assetTokenIDs,
    salePrice: params.salePrice,
    rentPrice: params.rentPrice,
    rentalPeriod: params.rentalPeriod,
    batch: params.batch,
  };

  dispatch(startListAsset());

  return listAssetAPI(options)
    .done((data, status, xhr) => {
      if (config.APP_DEBUG) {
        console.log("Headers: ", xhr.getAllResponseHeaders());
        console.log("Listed asset: ", data);
      }
      dispatch(
        listAsset({
          ajaxStat: AjaxStatus.DONE,
          response: data,
        })
      );
    })
    .fail((err) => {
      if (config.APP_DEBUG) {
        console.error("Error in listing asset");
      }
      dispatch(
        listAsset({
          response: {},
          ajaxStat: AjaxStatus.FAILED,
        })
      );
    });
};

export const offerTradingAssetDispatch =
  (params: any) => (dispatch: Function) => {
    let options = {
      submittedAssetTokenIDs: params.submittedAssetTokenIDs,
      requestedAssetTokenIDs: params.requestedAssetTokenIDs,
      waitOffers: params.waitOffers,
    };

    dispatch(startOfferTradingAsset());

    return offerTradingAssetAPI(options)
      .done((data, status, xhr) => {
        if (config.APP_DEBUG) {
          console.log("Headers: ", xhr.getAllResponseHeaders());
          console.log("offer Trading asset: ", data);
        }
        dispatch(
          offerTradingAsset({
            ajaxStat: AjaxStatus.DONE,
            response: data,
          })
        );
      })
      .fail((err) => {
        if (config.APP_DEBUG) {
          console.error("Error in offer trading asset");
        }
        dispatch(
          offerTradingAsset({
            response: {},
            ajaxStat: AjaxStatus.FAILED,
          })
        );
      });
  };

export const distributeAssetDispatch =
  (params: any) => (dispatch: Function) => {
    const options = {
      assetTokenIDs: params.assetTokenIDs,
      limitOnNumber: params.limitOnNumber,
      acquirers: params.acquirers,
      freeDistributionFee: params.freeDistributionFee,
      lang: params.lang,
    };

    let stripePromise;
    const getStripe = (publishable_key) => {
      if (!stripePromise) {
        stripePromise = loadStripe(publishable_key);
      }

      return stripePromise;
    };

    const redirectToCheckout = async (id, publishable_key) => {
      console.log("redirectToCheckout");
      const stripe = await getStripe(publishable_key);
      const { error } = await stripe.redirectToCheckout({ sessionId: id });
      console.log("Stripe checkout error", error);
    };

    dispatch(startDistributeAsset());

    return distributeAssetAPI(options)
      .done((data, status, xhr) => {
        if (config.APP_DEBUG) {
          console.log("Headers: ", xhr.getAllResponseHeaders());
          console.log("distributeAssetAPI asset: ", data);
        }
        dispatch(
          distributeAsset({
            ajaxStat: AjaxStatus.DONE,
            response: data,
          })
        );
        if (options.freeDistributionFee !== 0) {
          redirectToCheckout(data.id, data.key);
        }
      })
      .fail((err) => {
        if (config.APP_DEBUG) {
          console.error("Error in distributeAssetAPI");
        }
        dispatch(
          distributeAsset({
            response: {},
            ajaxStat: AjaxStatus.FAILED,
          })
        );
      });
  };

export const getFlowTransactionStatusDispatch =
  (params: any) => (dispatch: Function) => {
    let options = {
      transactionId: params.transactionId,
    };

    dispatch(startGetFlowTransactionStatus());

    return getFlowTransactionStatusAPI(options)
      .done((data, status, xhr) => {
        if (config.APP_DEBUG) {
          console.log("Headers: ", xhr.getAllResponseHeaders());
          console.log("Got Flow transaction status: ", data);
        }
        dispatch(
          getFlowTransactionStatus({
            ajaxStat: AjaxStatus.DONE,
            response: data,
          })
        );
      })
      .fail((err) => {
        if (config.APP_DEBUG) {
          console.error("Error in getting Flow transaction status");
        }
        dispatch(
          getFlowTransactionStatus({
            response: {},
            ajaxStat: AjaxStatus.FAILED,
          })
        );
      });
  };
